import { MouseEvent } from 'react';

import styles from './styles/LeftMenu.module.scss';

export function isInLayer(target: HTMLElement): boolean {
  return !!target.closest(`.${styles.layer}`);
}

export function isMenuItem(target: HTMLElement): boolean {
  return (target.tagName === 'a' || !!target.closest('a'));
}

export const preventClick = <T extends HTMLElement>(event: MouseEvent<T>): void => {
  event.preventDefault();
};
